import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
import { useRouter } from 'next/router'
// import { features, title } from 'process'
import React, { useState } from 'react'
import { THEME } from 'src/config/config'

import { PremiumModal } from '../PremiumModal'

/**
 * Primary UI component for user interaction
 */
export const LikeHiddenComponent: React.FC<{
  title?: string
  fromPage?: string
  className?: string
  notclick?: boolean
}> = ({ title, fromPage = '', className, notclick = false }) => {
  const router = useRouter()
  const [isPremiumModalVisible, setIsPremiumModalVisible] = useState(false)
  const randomNum = Math.floor(Math.random() * 1000) // Generates a number between 0 and 999

  if (notclick) {
    return (
      <p
        className={className}
        style={{ color: '#333333', fontFamily: 'Karla, sans-serif', fontSize: '15px', fontWeight: 'normal' }}
      >
        {THEME === 'ilta' ? 'No data provided' : 'Data unavailable'}
      </p>
    )
  }

  return (
    <>
      <PremiumModal
        origin={router.asPath}
        isOpen={isPremiumModalVisible}
        onClose={() => setIsPremiumModalVisible(false)}
      />
      <div
        key={randomNum + 'likeHiddenComponent-my-2'}
        className={cn(
          'my-2 select-none flex-row items-center cursor-pointer',
          fromPage === 'compare' ? 'inline-flex w-full' : 'flex',
          className,
        )}
        onClick={() => setIsPremiumModalVisible(true)}
      >
        <IonIcon
          key={randomNum + 'likeHiddenComponent-lock-closed'}
          name="lock-closed"
          className={cn(fromPage === 'compare' ? 'flex text-navy' : '', 'text-navy')}
          style={
            fromPage !== 'compare'
              ? {
                  display: 'inline-block' as const,
                  height: '1em',
                  width: '1em',
                  visibility: 'inherit' as const,
                  boxSizing: 'content-box' as const,
                  fontSize: '16px',
                }
              : { fontSize: '16px', width: '26px', height: '16px', display: 'flex' as const }
          }
        />
        <div
          key={randomNum + 'likeHiddenComponent-blur-sm'}
          className="blur-sm text-[15px] leading-[18px] tracking-normal font-primary ml-[12px] bg-gray-300"
        >
          {title || 'Upgrade to premium'}
        </div>
      </div>
    </>
  )
}
